/**
 
 */

import Vue from 'vue'

Vue.component('vs-error', require('./widgets/Error').default)
Vue.component('vs-title', require('./widgets/Title').default)
Vue.component('vs-paginator', require('./widgets/Paginator').default)
Vue.component('vs-loading', require('./widgets/Loading').default)